import React from 'react'

import { Fieldset, Input, PriceString } from '@fourthwall/components'

import { useTierContext } from '../../hooks/useTierContext'
import { FormFields } from '../../providers/TierProvider/types'
import * as S from './styled'

export const MonthDiscount = () => {
  const { form, annualDiscount, isLoading } = useTierContext()

  if (form.values.discountType !== 'oneTime') return null
  if (form.values.price && parseFloat(form.values.price) === 0) return null
  if (!form.values.discount) return null

  const renderMonthDiscountInfo = () => {
    if (
      !form.values.price ||
      !form.values.monthDiscount ||
      parseInt(form.values.monthDiscount) > 100 ||
      parseInt(form.values.monthDiscount) < 0
    )
      return null

    return (
      <S.DiscountInfo>
        <S.DiscountInfoLabel>First month</S.DiscountInfoLabel>
        <PriceString
          value={
            form.values.price
              ? Math.floor(
                  (parseFloat(form.values.price) -
                    parseFloat(form.values.price) * (parseInt(form.values.monthDiscount) / 100)) *
                    100,
                ) / 100
              : 0
          }
        />
      </S.DiscountInfo>
    )
  }

  return (
    <Fieldset.Row inner>
      <S.Container>
        {annualDiscount && <S.DisountLabel>Monthly membership</S.DisountLabel>}
        <S.DiscountInputContainer>
          <Input
            label="First month discount"
            type="number"
            append="%"
            hideSpinner
            disabled={isLoading}
            {...form.getFieldProps(FormFields.monthDiscount)}
          />
          {renderMonthDiscountInfo()}
        </S.DiscountInputContainer>
      </S.Container>
    </Fieldset.Row>
  )
}
